export default {"src":"/_next/static/media/pro_planet_yellow.4b57acff.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};